import { makeRequest } from '../client'

export const login = async (data) => makeRequest('auth', 'login', data);

export const register = async (data) => makeRequest('auth', 'register', data);

export const getUserProfile = async () => makeRequest('user', 'getUserProfile', {});
